
const CLI_CLAIM_TYPES = [
  { value: "RETRENCHMENT", label: 'Retrenchment' },
  { value: "COMPULSORY_UNPAID_LEAVE", label: 'Compulsory Unpaid Leave' },
  { value: "TTD", label: 'Temporary Total Disability (TTD)' },
  { value: "DEATH", label: 'Death' },
]

export default CLI_CLAIM_TYPES 
